import React, { ReactElement } from 'react';

import { ReactComponent as MoLogo } from './assets/motability-smart-logo.svg';
import styles from './header.module.scss';

interface HeaderProps {
    className: string;
}

const Header: React.FunctionComponent<HeaderProps> = ({ className }: HeaderProps): ReactElement => {
    return (
        <header className={className}>
            <div className={styles.gridContainer}>
                <nav className={styles.headerNav}>
                    <div className={styles.logoContainer}>
                        <MoLogo />
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
